import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import { Link } from "react-router-dom";
import Item from "./components/Item";
import { Loader } from "components";

const LastPacked = () => {
  const { isLoading, isFetching, data, refetch } = useQuery(
    ["dashboard_gdns_lastly_completed"],
    () => client_v2.get("/stats/dashboard_gdns_lastly_completed"),
    {
      select: (res) => res.data,
      retry: false,
    }
  );
  const is_loading = isLoading || isFetching;
  return (
    <div className="dashboard">
      <div className="history-box__header">
        <span className="title">Ostatnio spakowane</span>
        {is_loading ? (
          <Loader size="20" />
        ) : (
          <button className="btn btn-default" onClick={refetch}>Odśwież</button>
        )}
      </div>
      {data?.length > 0 && (
        <ul className="history-box__body">
          {data.map((data) => (
            <Item key={data.identifier} {...data} />
          ))}
        </ul>
      )}
      <div className="history-box__footer">
        <Link to="/gdns" className="btn-link">
          Logi wysyłki
        </Link>
      </div>
    </div>
  );
};

export default LastPacked;
